import { Events } from '../events/events.js';

export class Cast {
  currentSession = null;
  config = null;
  bootAttempts = 0;
  receiverAppId = 'AA1EEEA6';
  events = {};
  castStatus = null;

  constructor(_this, contentId, elementSelector, options) {
    this.self = _this;
    this.contentId = contentId;
    this.elementSelector = elementSelector;
    this.options = options;


    var _this = this; // No es el de arriba

    window['__onGCastApiAvailable'] = function (isAvailable) {
      if (isAvailable) {
        _this.initializeCastApi();
      }
    };

    // Para cordova
    document.addEventListener("deviceready", function () {
      if (window.chrome && window.chrome.cast && window.chrome.cast.isAvailable) {
        _this.initializeCastApi();
      }
    });

  }

  // Método para registrar un evento y su manejador
  on(event, listener) {
    if (!this.events[event]) {
      this.events[event] = [];
    }
    this.events[event].push(listener);
  }

  // Método para emitir un evento y ejecutar todos los manejadores registrados
  emit(event, ...args) {
    if (this.events[event]) {
      this.events[event].forEach(listener => listener(...args));
    }
  }

  // Método para eliminar un manejador específico de un evento
  off(event, listenerToRemove) {
    if (!this.events[event]) return;

    this.events[event] = this.events[event].filter(listener => listener !== listenerToRemove);
  }

  /**
   * Inicializamos la API de Cast
   *
   */
  initializeCastApi() {
    this.bootAttempts++;

    this.sessionListener = this.sessionListener.bind(this);
    this.onReceiverMessage = this.onReceiverMessage.bind(this);

    if (window.chrome) {
      this.config = new chrome.cast.ApiConfig(new chrome.cast.SessionRequest(this.receiverAppId),
        (session) => {  // sessionListener   
          console.log('[Cast] Connected');
          this.currentSession = session;
          this.currentSession.addUpdateListener(this.sessionListener);
          this.currentSession.addMessageListener('urn:x-cast:com.taurobroadcast.cast', this.onReceiverMessage);

          // Lanzamos el evento de cambio de estado
          this.emit(Events.CAST_STATUS_CHANGE, this.currentSession);

        }, (e) => { // receiverListener
        }, chrome.cast.AutoJoinPolicy.ORIGIN_SCOPED);

      chrome.cast.initialize(this.config, (e) => {        

        // Lanzamos el evento de disponibilidad de Chromecast
        this.emit(Events.CAST_AVAILABLE, true);

      }, (e) => {
        console.error('[Cast] API initialization failed', e);

        // Lanzamos el evento de disponibilidad de Chromecast
        this.emit(Events.CAST_AVAILABLE, false);
      });
    }

  }

  sessionListener(isAlive) {

    if (!this.currentSession) {
      return;
    }

    switch (this.currentSession.status) {
      case chrome.cast.SessionStatus.CONNECTED:

        // Escuchamos los mensajes del receptor
        this.currentSession.addMessageListener('urn:x-cast:com.taurobroadcast.cast', this.onReceiverMessage);
        console.log('[Cast] Connected');

        break;
      case chrome.cast.SessionStatus.STOPPED:
      case chrome.cast.SessionStatus.DISCONNECTED:
        console.log('[Cast] Disconnected');
        this.currentSession = null;
        break;
      default:
        break;
    }

    // Lanzamos el evento de cambio de estado
    this.emit(Events.CAST_STATUS_CHANGE, this.currentSession);

  }

  /**
   * Función que se ejecuta cuando se recibe un mensaje del receptor
   *
   * @param {*} namespace 
   * @param {*} message 
   */
  onReceiverMessage(namespace, message) {
    // console.log('Message received: ' + message);

    var data = JSON.parse(message);
    window.castStatus = data.status;

    // Lanzamos el evento de mensaje
    this.emit(Events.CAST_MESSAGE, data);

  }

  /**
   * Lanza la reproducción en Chromecast
   *
   * @param {*} oplayer 
   * @param {*} pwindow 
   * @return 
   */
  castLaunch() {
    if (!window.chrome || !window.chrome.cast || !window.chrome.cast.isAvailable) {
      return;
    }

    // Si no hay sesión, solicitamos una
    chrome.cast.requestSession((session) => {
      this.currentSession = session;
      this.currentSession.addUpdateListener(this.sessionListener);
      this.currentSession.addMessageListener('urn:x-cast:com.taurobroadcast.cast', this.onReceiverMessage);
    }, (error) => {
      window.castStatus = null;
      console.info('[Cast] Requesting session', error);
    }, new chrome.cast.SessionRequest(this.receiverAppId));


  }

  /**
   * Se envía el contenido al receptor Chromecast
   *
   * @param {*} oplayer 
   * @param {*} pwindow 
   */
  sessionLoad(content) {
    this.sendMessage({
      type: 'LOAD',
      content: content,
    });
  }

  /**
   * Se hace tracking del tiempo de reproducción en Chromecast
   *
   * @param {*} secs 
   */
  seek(secs) {
    this.sendMessage({
      type: 'SEEK',
      currentTime: secs,
    });
  }

  /**
   * Enviamos PLAY al receptor Chromecast
   *
   * @param {*} secs 
   */
  play() {
    this.sendMessage({
      type: 'PLAY'
    });
  }

  /**
   * Enviamos PAUSE al receptor Chromecast
   * 
   */
  pause() {
    this.sendMessage({
      type: 'PAUSE',
    });
  }

  /**
   * Se envía un mensaje al receptor Chromecast
   *
   * @param {*} message 
   * @return 
   */
  sendMessage(message) {
    if (!this.currentSession) {
      return;
    }

    this.currentSession.sendMessage('urn:x-cast:com.taurobroadcast.cast', message);
  }

  /**
   * Cerramos la sesión de Chromecast
   *
   */
  close() {
    this.castStatus = null;
    if (this.currentSession !== null) {
      this.currentSession.stop(() => {
        console.log('[Cast] Session stopped');
        this.currentSession = null;
      }, (error) => {
        console.error('[Cast] Error stopping session', error);
      });

    }
  }

  /**
   * Paramos el contenido en Chromecast
   *
   */
  stop() {
    this.sendMessage({
      type: 'STOP',
    });
  }
}
